const VERIFICATION_STATUSES = {
  Approved: 'Approved',
  Declined: 'Declined',
  Verification: 'Verification',
};

export default VERIFICATION_STATUSES;
